import Marquee from "react-fast-marquee";

const WORDS = ["Good Food", "Healthy Living", "Snack Smart", "Live Bold", "Big Crunch", "Bold Flavour"];

export default function BrandMarquee() {
  return (
    <div className="border-y border-white/10 bg-black py-6" data-testid="brand-marquee">
      <Marquee speed={55} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className={`font-display text-4xl tracking-wide sm:text-6xl ${i % 2 ? "text-stroke-gold" : "text-cream"}`}>
              {w}
            </span>
            <span className="text-3xl text-gold">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
